import { Grid, Link, ListRow, ListTextIconCol, useMediaQ } from '@csp/csp-web-ui';
import { FC } from 'react';
import { BioSampleCodeComponent } from '../../component/BioSampleCodeComponent';
import { PatientCol } from '../../component/PatientCol';
import { SampleStatusCol } from '../../component/SampleStatusCol';
import { BioSampleContainerItem } from '../../model/BioSampleContainerItem';
import { KitContainersColSettings } from '../model/KitContainersColSettings';
import { useBioSampleDetailsNavigation } from '../../../barcode-input/hook/useBioSampleDetailsNavigation';
import { BioSampleContentService } from '../../service/BioSampleContentService';

type Props = {
  container: BioSampleContainerItem;
};

const { containerWidth, descriptionWidth, statusWidth, patientVisitWidth, actionsWidth, actionsMy, my, pr } =
  KitContainersColSettings.cols;

export const KitContainerListRow: FC<Props> = ({ container }) => {
  const lgUp = useMediaQ('lg', 'up');
  const bioSampleDetailsToggle = useBioSampleDetailsNavigation();
  const texts = BioSampleContentService.getKitDetailsTexts();

  const sampleId = container.bioSampleItem?.sampleId;

  return (
    <ListRow
      key={container.sampleContainerCode}
      container
      alignItems={lgUp ? 'top' : 'flex-start'}
      p={2}
      bgcolor="common.white"
      outlined
    >
      <ListTextIconCol
        title={container.display.sampleContainerCodeLabel}
        my={my}
        pr={pr}
        {...containerWidth}
        text={
          <BioSampleCodeComponent
            kitCode={container.display.kitCode}
            containerNumber={container.display.containerNumber}
            sampleCode={container.display.sampleContainerCode}
          />
        }
      />
      <ListTextIconCol
        title={container.display.containerDescriptionLabel}
        text={container.display.containerDescription}
        my={my}
        pr={pr}
        noWrap={false}
        {...descriptionWidth}
      />
      <SampleStatusCol
        sampleStatus={container.display.sampleStatus}
        sampleStatusDateTime={container.display.sampleStatusDateTime}
        sampleStatusLabel={container.display.sampleStatusLabel}
        hideTitle={lgUp || (!container.display.sampleStatus && !container.display.sampleStatusDateTime)}
        my={my}
        pr={pr}
        {...statusWidth}
      />
      <PatientCol
        label={container.display.containerPatientVisitLabel}
        ecode={container.display.ecode}
        visitName={container.display.visitName}
        hideTitle={lgUp || (!container.display.ecode && !container.display.visitName)}
        my={my}
        pr={pr}
        {...patientVisitWidth}
      />

      {sampleId && (
        <Grid item {...actionsWidth} my={actionsMy} pr={pr} textAlign={{ md: 'left', lg: 'center' }}>
          <Link onClick={(): void => bioSampleDetailsToggle.open({ sampleId })} color="primary">
            {texts.drawer.button.viewSampleDetails.label}
          </Link>
        </Grid>
      )}
    </ListRow>
  );
};
